<template>
  <div>
    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          Start
        </b-input-group-prepend>
        <b-form-select v-model="term"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termId"
                      text-field="description"
                      />
      </b-input-group>

      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          End
        </b-input-group-prepend>
        <b-form-select v-model="termEnd"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termId"
                      text-field="description"
                      />
      </b-input-group>
    </b-form>
    <bar-chart :chart-data="itemsData"></bar-chart>
  </div>
</template>

<script>
import * as _ from "lodash";
import opportunityReportsApi from "../../api/opportunityReporting";
import termsApi from "../../api/terms";
export default {
  data() {
    return {
      items: [],
      terms: [],
      term: null,
      termEnd: null,
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)"
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)"
      ]
    };
  },
  computed: {
    itemsData: function() {
      var that = this;

      var formattedData = {
        labels: [],
        datasets: []
      };
      var colorIndex = 0;
      _.forEach(this.items, item => {
        var dataset = {
          label: item.label,
          borderWidth: 1,
          data: [],
          backgroundColor: [],
          borderColor: []
        };

        _.forEach(item.collection, term => {
          dataset.backgroundColor.push(this.colors[colorIndex]);
          dataset.borderColor.push(this.borderColors[colorIndex]);
          dataset.data.push(term.total);
          if (!formattedData.labels.includes(term.term.description)) {
            formattedData.labels.push(term.term.description);
          }
        });

        formattedData.datasets.push(dataset);

        if (colorIndex < that.colors.length - 1) {
          colorIndex++;
        } else {
          colorIndex = 0;
        }
      });

      return formattedData;
    }
  },
  methods: {
    changeTerm() {
      this.getData();
    },
    getData() {
      opportunityReportsApi.getSemesterTotals(this.term, this.termEnd).then(response => {
        this.items = response.data;
      });
    }
  },
  created() {
    termsApi.getPastTerms().then(response => {
      this.terms = response.data;
    });
    this.getData();
  }
};
</script>

<style scoped>
</style>
